<template>
  <div class="user-page full-height">
    <table-con :canReturn="canReturn">
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title">{{$t('fba.packNo')}}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.boxNo" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">{{$t('fba.stocktakeState')}}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.checkStatus" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                <el-option key="" value="" :label="$t('common.all')"></el-option>
                <el-option key="0" value="0" :label="$t('fba.unstocktake')"></el-option>
                <el-option key="1" value="1" :label="$t('fba.stocktaked')"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">{{$t('common.createStartDate')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">{{$t('common.createEndDate')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('common.reset')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('common.search')}}</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.batchNo')}}:</div>
            <div class="query-content">{{containerInfo.containerBatchNo}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.boxCount')}}:</div>
            <div class="query-content">{{containerInfo.containerBoxesCount}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.totalNetWeight')}}:</div>
            <div class="query-content">{{containerInfo.totalNetWeight}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.totalRealWeight')}}:</div>
            <div class="query-content">{{containerInfo.realWeight}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.totalThrowWeight')}}:</div>
            <div class="query-content">{{containerInfo.throwWeight}}</div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border stripe
          style="width: 100%" height="550">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column prop="boxNo" align="center" :label="$t('fba.packNo')"></el-table-column>
          <el-table-column prop="createTime" width="160" align="center" :label="$t('common.createDate')" :formatter="formatDate">
          </el-table-column>
          <!--          <el-table-column prop="createUserName" align="center" label="创建人"></el-table-column>-->
          <el-table-column prop="boxGoodsCount" align="center" :label="$t('fba.goodsNumber')"></el-table-column>
          <el-table-column prop="realWeight" align="center" :label="$t('fba.solidWeight')"></el-table-column>
          <el-table-column prop="throwWeight" align="center" :label="$t('fba.throwingWeight')"></el-table-column>
          <el-table-column prop="materialName" align="center" :label="`${$t('OrderDetail.OrderDetail5')}`"></el-table-column>
          <el-table-column prop="checkStatus" align="center" :label="$t('fba.stocktakeState')">
            <template v-slot="scope">
              {{scope.row.checkStatus == '0' ? $t('fba.unstocktake') :$t('fba.stocktaked')}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operate')" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <!-- <el-button class="list-btn btn-blue" @click="handleEdit(scope.row)">
                  {{$t('editor')}}
                </el-button> -->
                <el-button class="list-btn btn-blue" @click="toOrderDetail(scope.row)">
                  {{$t('common.detail')}}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 20, 50, 100]" :pager-count="5" :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination> -->
      </div>
    </table-con>
    <el-dialog :title="$t('fba.mergePack')" :visible.sync="visible1" width="600px">
      <el-form :model="editInfo" :rules="rules1" ref="editInfo" label-width="120px">
        <el-form-item prop="realWeight" :label="$t('fba.solidWeight')">
          <el-input-number v-model="editInfo.realWeight" :precision="2" :step="0.1" :min="0" :controls='false'></el-input-number>
        </el-form-item>
        <div class="throw" style="display: flex;align-items: center;">
          <div style="width: 110px;text-align: right;margin-right: 10px;">{{$t('OrderDetail.OrderDetail9')}}</div>
          <el-form-item prop="boxLong" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxLong" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          <span class="symbol">*</span>
          <el-form-item prop="boxWidth" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxWidth" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          <span class="symbol">*</span>
          <el-form-item prop="boxHeight" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxHeight" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          <span class="symbol">/</span>
          <el-form-item prop="boxDivisor" style="width:60px;margin-bottom:0px">
            <el-input-number style="width:60px" v-model="editInfo.boxDivisor" :precision="0" :min="0" :controls='false'>
            </el-input-number>
          </el-form-item>
          KG
        </div>
        <el-form-item prop="boxTypeId" style="margin-top:20px" :label="$t('OrderDetail.OrderDetail5')">
          <el-select v-model="editInfo.boxTypeId" :placeholder="$t('goods.goods21')" clearable>
            <el-option v-for="(item,index) in configLists.boxConfigList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="saveEdit">{{$t('common.confirm')}}</el-button>
        <el-button class="form-btn btn-gray" @click="visible1=false">{{$t('common.cancel')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('fba.movePack')" :visible.sync="updateDialogVisible" width="30%" @close="updateDialogClose">
      <el-form :model="boxInfo" :rules="rules" ref="boxInfo" label-width="120px" class="demo-boxInfo">
        <el-form-item :label="$t('fba.movedPackNo')">
          {{boxInfo.containerBatchNo}}-{{boxInfo.boxNo}}
        </el-form-item>
        <el-form-item :label="$t('fba.targetBatchNo')" prop="targetContainerBatchNo">
          <el-select v-model="boxInfo.targetContainerBatchNo" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
            <el-option v-for="item in containerBatchNoOptions" :key="item.containerBatchNo" :label="item.containerBatchNo"
              :value="item.containerBatchNo">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="updateSave('boxInfo')">{{$t('common.confirm')}}</el-button>
        <el-button class="form-btn btn-gray" @click="clearForm">{{$t('common.cancel')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('fba.mergePack')" :visible.sync="mergeDialogVisible" width="30%" @close="updateDialogClose">
      <el-form :model="mergeBoxInfo" :rules="rules" ref="mergeBoxInfo" label-width="120px" class="demo-boxInfo">
        <el-form-item :label="$t('fba.mergedPackNo')">
          {{$t('fba.packNo')}}{{mergeBoxInfo.boxNo}}
        </el-form-item>
        <el-form-item :label="$t('fba.targetBatchNo')" prop="targetContainerBatchNo">
          <el-select v-model="mergeBoxInfo.targetContainerBatchNo" :placeholder="$t('common.pleaseSelect')" size="small"
            @change="onSelectedDrug" clearable>
            <el-option v-for="item in containerBatchNoOptions" :key="item.containerBatchNo" :label="item.containerBatchNo"
              :value="item.containerBatchNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('fba.targetPackNo')" prop="targetBoxNo">
          <el-select v-model="mergeBoxInfo.targetBoxNo" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
            <el-option v-for="item in boxNoOptions" :key="item.boxNo" :label="item.boxNo" :value="item.boxNo">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="updateMergeSave('mergeBoxInfo')">{{$t('common.confirm')}}</el-button>
        <el-button class="form-btn btn-gray" @click="clearForm">{{$t('common.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import tableCon from '../../views/tableContainer'
export default {
  data () {
    return {
      containerInfo: {
        containerBatchNo: '',
        containerBoxesCount: 0,
        realWeight: 0.0,
        throwWeight: 0.0,
        totalNetWeight: 0.0,
        oppCount: 0
      },
      visible1: false,
      canReturn: '1',
      pageTitle: this.$t('fba.packDetail'),
      boxId: '',
      boxInfo: {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: ''
      },
      mergeBoxInfo: {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: '',
        targetBoxNo: '',
      },
      queryInfo: {
        containerBatchNo: '',
        boxNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 9999,
        pageNum: 1,
      },
      editInfo: {
        boxDivisor: "",
        realWeight: "",
        boxHeight: "",
        boxLong: "",
        boxWidth: "",
        boxTypeId: "",
      },
      rules1: {
        realWeight: [
          { required: true, message: this.$t('createOrder.createOrder84'), trigger: 'blur' }
        ],
        boxDivisor: [
          { required: true, message: this.$t('createOrder.createOrder84'), trigger: 'blur' }
        ],
        boxHeight: [
          { required: true, message: this.$t('createOrder.createOrder84'), trigger: 'blur' }
        ],
        boxLong: [
          { required: true, message: this.$t('createOrder.createOrder84'), trigger: 'blur' }
        ],
        boxWidth: [
          { required: true, message: this.$t('createOrder.createOrder84'), trigger: 'blur' }
        ],
        boxTypeId: [
          { required: true, message: this.$t('mess.mess33'), trigger: 'change' }
        ],
      },
      containerBatchNoOptions: [],
      boxNoOptions: [],
      rules: {
        targetContainerBatchNo: [
          { required: true, message: this.$t('fba.selectTargetBatch'), trigger: 'blur' }
        ]
      },
      id: "",
      configLists: [],
      boxDateRangeValue: [],
      orderList: [],
      total: 0,
      updateDialogVisible: false,
      mergeDialogVisible: false
    };
  },
  components: { tableCon },
  methods: {
    formatDate (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    async getConfigLists () {
      const { data: res } = await this.$http.get(
        "order/getOrderInfoConfigList"
      );
      this.configLists = res.data;
    },
    orderDateRange () {
    },
    shipDateRange () {
    },
    queryInfoClear () {
      this.queryInfo = {
        containerBatchNo: this.queryInfo.containerBatchNo,
        boxNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 9999,
        pageNum: 1,
      }
      this.boxDateRangeValue = [];
    },
    saveEdit () {
      this.$refs.editInfo.validate((valid) => {
        if (valid) {
          this.editInfo.id = this.id
          this.$http.post('box/updateBox', this.editInfo).then((res) => {
            console.log(res)
            if (res.data.code == 200) {
              this.visible1 = false
              this.getOrderList()
              this.$message.success('操作成功')
            }
          })
        }
      })
    },
    handleEdit (row) {
      this.editInfo = row
      this.visible1 = true
      this.id = row.id
    },
    clearForm () {   //弹窗的取消按钮
      this.initForm();
      this.updateDialogVisible = false;
      this.mergeDialogVisible = false;
    },
    initForm () {   //初始化弹窗的内容
      this.boxInfo = {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: ''
      };
      this.mergeBoxInfo = {
        id: '',
        boxNo: '',
        containerBatchNo: '',
        targetContainerBatchNo: '',
        targetBoxNo: '',
      };
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    categoryFlagChanged (row) {
      //改变状态接口 params row.No,row.categoryFlag
      console.log(row.categoryFlag);
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag;
        alert('failed')
      }, 1000);

    },
    async getContainerInfo () {
      const { data: res } = await this.$http.get('container/getContainerInfo/' + this.queryInfo.containerBatchNo);
      this.containerInfo = res.data;
    },
    async getOrderList () {
      const { data: res } = await this.$http.get("box/list", { params: this.queryInfo });
      this.orderList = res.data.list;
      this.total = res.data.total;
      this.total = this.orderList.length;
    },
    async getContainerList (boxId) {
      const { data: res } = await this.$http.get('container/getMoveContainerList/' + boxId);
      this.containerBatchNoOptions = res.data;
    },
    async getBoxList (containerBatchNo) {
      const { data: res } = await this.$http.get('box/getBoxList/' + containerBatchNo);
      this.boxNoOptions = res.data;
    },
    // 条线改变事件
    onSelectedDrug: function (val) {
      this.mergeBoxInfo.targetBoxNo = '';
      this.getBoxList(val);
    },
    toOrderDetail (row) {
      console.log(row);
      this.$router.push({
        name: 'boxOrderList',
        query: {
          boxNo: row.boxNo,
          containerBatchNo: this.queryInfo.containerBatchNo
        }
      })
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
    },
    updateDialogClose () {    //关闭弹窗
      this.updateDialogVisible = false;
      this.mergeDialogVisible = false;
    },
    updateSave (formName) {    //保存按钮
      var my = this;
      //保存按钮
      this.$refs.boxInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "box/moveBox";
          const { data: res } = await my.$http.post(url, my.boxInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getOrderList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    updateMergeSave (formName) {    //保存按钮
      var my = this;
      //保存按钮
      this.$refs.mergeBoxInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          console.log(my.mergeBoxInfo)
          var url = "box/mergeBox";
          const { data: res } = await my.$http.post(url, my.mergeBoxInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getOrderList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    boxDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.boxDateRangeValue) {
        this.boxDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      }
      else {
        if (this.boxDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.boxDateRangeValue[0] / 1000;
          this.queryInfo.createTimeEnd = this.boxDateRangeValue[1] / 1000;
        }
      }

    },
  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem('token')) {
        return false;
      }
    }
  },
  created () {
    this.queryInfo.containerBatchNo = this.$route.query.containerBatchNo;
    this.getOrderList();
    this.getContainerInfo();
    this.getConfigLists()
  },
};
</script>

<style lang="less" scoped>
.query-content {
  margin-top: 5px;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
.throw {
  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
  .symbol {
    margin: 0 15px;
  }
}
</style>
